import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrFleetinfoAddPage } from './klmr-fleetinfo-add';

@NgModule({
  declarations: [
    KlmrFleetinfoAddPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrFleetinfoAddPage),
  ],
})
export class KlmrFleetinfoAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-fleetinfo-add/klmr-fleetinfo-add.module.ts